import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { gapConverterMap } from './gapPropsToCss'

/**
 * Enriches the converters registry with all Gap style property converters.
 * Gap converters handle CSS gap property values (row-gap and column-gap).
 */
export function enrichGapConverters(): void {
	// Register all gap converters
	Object.entries(gapConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
